import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { AlarmFilledSVG, CheckFilledSVG, CrossFilledSVG, InfoFilledSVG } from '@snack-uikit/icons';
import { VALIDATION_STATE } from '../../constants';
import styles from './styles.module.css';
function getValidationIcon(props) {
    var _a;
    let Component;
    let showIcon;
    switch (props.validationState) {
        case VALIDATION_STATE.Success:
            Component = CheckFilledSVG;
            showIcon = true;
            break;
        case VALIDATION_STATE.Error:
            Component = CrossFilledSVG;
            showIcon = true;
            break;
        case VALIDATION_STATE.Warning:
            Component = AlarmFilledSVG;
            showIcon = true;
            break;
        case VALIDATION_STATE.Default:
        default:
            Component = InfoFilledSVG;
            showIcon = false;
            break;
    }
    return ((_a = props.showHintIcon) !== null && _a !== void 0 ? _a : showIcon) ? (_jsx(Component, { size: 16, "data-validation": props.validationState, className: styles.hintIcon })) : null;
}
export function Footer({ length, hint, size, validationState = VALIDATION_STATE.Default, showHintIcon }) {
    const isReverseContainer = !hint && length;
    const limitExceeded = length && length.max && length.current > length.max;
    const icon = useMemo(() => getValidationIcon({ validationState, showHintIcon }), [showHintIcon, validationState]);
    if (!hint && !length) {
        return null;
    }
    return (_jsxs("span", { className: styles.footer, "data-reverse": isReverseContainer || undefined, "data-size": size, children: [hint && (_jsxs("span", { className: styles.hintLayout, children: [icon && (_jsx("span", { className: styles.hintIconContainer, "data-size": size, children: icon })), _jsx("span", { className: styles.hint, "data-validation": validationState, "data-test-id": 'field-decorator__hint', children: hint })] })), length && (_jsxs("span", { "data-test-id": 'field-decorator__counter', className: styles.counterLimit, children: [_jsx("span", { "data-validation": validationState, "data-limit-exceeded": limitExceeded || undefined, className: styles.counterCurrentValue, "data-test-id": 'field-decorator__counter-current-value', children: length.current }), _jsxs("span", { "data-validation": validationState, "data-limit-exceeded": limitExceeded || undefined, "data-test-id": 'field-decorator__counter-limit-value', children: ["/", length.max] })] }))] }));
}
